import { Box, Text } from "@chakra-ui/react";
import Chart from "react-apexcharts";
import { useEffect, useState } from "react";

const PieChart = ({ scoreCount }) => {
  console.log(scoreCount)
  const pieChartData = {
    series: [],
    options: {
      labels: [],
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "left",
      },
    },
  };
  const [state, setState] = useState(pieChartData);

  useEffect(() => {
    if (Object.keys(scoreCount).length !== 0) parseData(scoreCount);
  }, []);

  const parseData = (scoreCount) => {
    let series = [];
    let labels = [];
    for (let key in scoreCount) {
      labels.push(key);
      series.push(Number(scoreCount[key]));
    }
    setState({ series: series, options: { labels: labels } });
  };

  return (
    <Box borderWidth="1px" borderRadius="lg" p="2">
      <Text textAlign="center">Score Interpretation in the Pools</Text>
      <Chart
        style={
          Object.keys(scoreCount).length === 0
            ? { display: "none" }
            : { display: "block" }
        }
        options={state.options}
        series={state.series}
        type="pie"
        width="350"
        height="350"
      />
    </Box>
  );
};

export default PieChart;
